import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InfiniteScroll } from 'src/app/interfaces/interfaces';
import { HttpService } from 'src/app/services/http.service';
import { Review } from 'src/app/types';

@Component({
  selector: 'app-operator-card',
  templateUrl: './operator-card.component.html',
  styleUrls: ['./operator-card.component.scss'],
})
export class OperatorCardComponent implements OnInit {
  @Input() operator: any = undefined;
  @Output() emitUnSelect = new EventEmitter();
  public operatorReviews: Review[] = [];
  public totalPages = undefined;
  public actualPage = 1;
  public loading = true;

  constructor(private httpSv: HttpService) {}

  ngOnInit() {
    console.log('operator :>> ', this.operator);
  }

  async getOperatorReviews() {
    const res = await this.httpSv.itemIndex('operatorReviews', '', {
      operatorId: this.operator.id,
      pag: this.actualPage,
    });

    const response = res.data;
    this.operatorReviews.push(...response.data);
    this.loading = false;
    this.totalPages = response.meta.last_page;
  }

  async loadData(ev: InfiniteScroll) {
    if (this.actualPage > this.totalPages && this.totalPages !== undefined) {
      ev.disconnect();
      ev.complete();
    } else {
      await this.getOperatorReviews();
      this.actualPage++;
      ev.observe();
    }
  }

  unSelectOperator() {
    this.emitUnSelect.emit();
  }
}
